import { Injectable, Signal, inject } from '@angular/core';
import { APP_ACTIONS, type AppActionsApi } from '@app/core/app.actions';
import { RxState } from '@rx-angular/state';
import { MovementDetail } from '@vessel-reports/state/vessel-reports.types';
import { Vessel } from '@vessel/vessel/state/vessel.types';
import { Pagination, VesselItinerary } from './itinerary.types';

interface IItineraryState {
  itineraries: VesselItinerary[];
  pagination: Pagination;
  detailItinerary: VesselItinerary;
  detailVessel: Vessel;
  ports: any[];
  agentCompanies: any[];
  purposeIds: any[];
  vesselMovements: MovementDetail[];
}

@Injectable({
  providedIn: 'root'
})
export class ItineraryState extends RxState<IItineraryState> {
  protected readonly appActions: AppActionsApi = inject(APP_ACTIONS);

  pagination: Signal<Pagination> = this.signal('pagination');
  itineraries: Signal<VesselItinerary[]> = this.signal('itineraries');
  detailItinerary: Signal<VesselItinerary> = this.signal('detailItinerary');
  detailVessel: Signal<Vessel> = this.signal('detailVessel');
  ports: Signal<any[]> = this.signal('ports');
  agentCompanies: Signal<any[]> = this.signal('agentCompanies');
  purposeIds: Signal<any[]> = this.signal('purposeIds');
  vesselMovements: Signal<MovementDetail[]> = this.signal('vesselMovements');

  constructor() {
    super();
    this.hold(this.appActions.resetAll$, () => {
      this.reset();
    });
  }

  // Add reset method to clear itinerary state
  reset() {
    this.set({
      pagination: {} as Pagination,
      itineraries: [],
      detailItinerary: {} as VesselItinerary,
      detailVessel: {} as Vessel,
      ports: [],
      agentCompanies: [],
      purposeIds: [],
      vesselMovements: []
    });
  }
}
